import { Component, Vue } from 'vue-property-decorator';

@Component
export class ConfigurationMixins extends Vue {


    public onContentReady(component, element: HTMLElement,  model) 
    { 
        component.element.addEventListener('mouseover', () => this.mouseOverEvent(
            (component.element as HTMLElement).querySelector('input.dx-texteditor-input'),
            (component.element as HTMLElement).querySelector('div.dx-texteditor-input-container')
        ));
    }

	public addedEventMouse(component, element: HTMLElement,  model) { 

		const elems = new Set([
            ...document.querySelectorAll('.dx-item-content')
        ]);
  

		elems.forEach((textBox: HTMLElement) => {
            textBox.addEventListener('mouseover', () => this.mouseOverEvent(textBox.lastChild, textBox));
        });
        
	}

    public mouseOverEvent(element: any, textBox: any) { 

        if(element && element instanceof HTMLElement == false) { 
            const spanElement = (document.createElement('span') as HTMLSpanElement);
            spanElement.appendChild(element);
            spanElement.style.display = 'inline-block';
            spanElement.style.textOverflow = 'ellipsis';
            textBox.append(spanElement);
            spanElement.style.width = (spanElement as HTMLSpanElement).clientWidth + 'px';

            element = spanElement;
        }
        
        element = (element as HTMLElement);
        
        const boxWidth  = parseFloat(getComputedStyle(textBox).width);
        const textWidth= this.calculateWidth(element);
        const text = (element.textContent as string) != '' ? (element.textContent as string) : (element.value as string);

        this.assignTitle(element,boxWidth, textWidth, text);
    }



    public existsText(element: HTMLElement) :  boolean {
        if(element && element.getAttribute('title')  !== '' &&  element.getAttribute('title')  !== null)
            return true;

        return false;
    }

    public calculateWidth(element: HTMLElement): number {
        return element.clientWidth;
    }

    public assignTitle(element:HTMLElement, boxWidth :number, width:number, text: string): void {
        
        const overflowSize = boxWidth - width;

        if(overflowSize <= 0.9999999) {
            element.setAttribute('title',text);
        }
    }

}



export default new ConfigurationMixins();

